'use client';

import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import { Badge } from './Badge';
import { AutoneTooltip } from './Tooltip';
import { cn } from './utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    showTooltip?: boolean;
    startLabel?: string;
    endLabel?: string;
    displayValue?: string;
    tooltip?: string;
  }
>(
  (
    {
      className,
      showTooltip,
      startLabel,
      endLabel,
      displayValue,
      tooltip,
      ...props
    },
    ref,
  ) => (
    <div className="relative pt-1 pb-2">
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          'relative flex w-full touch-none select-none items-center',
          className,
        )}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary">
          <SliderPrimitive.Range className="absolute h-full bg-primary" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-primary bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
          {showTooltip && (
            <AutoneTooltip asChild text={tooltip ? tooltip : ''}>
              <Badge className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 -top-6 text-white bg-primary text-sm font-normal">
                <span>{displayValue ?? props.value}</span>
                <div className="absolute border-[6px] left-1/2 -translate-x-1/2 border-transparent border-t-primary top-full" />
              </Badge>
            </AutoneTooltip>
          )}
        </SliderPrimitive.Thumb>
      </SliderPrimitive.Root>
      {startLabel && (
        <span className="absolute bottom-0 left-0 text-sm text-muted-foreground -translate-x-2 translate-y-1 text-grey-40">
          {startLabel}
        </span>
      )}
      {endLabel && (
        <span className="absolute bottom-0 right-0 text-sm text-muted-foreground translate-x-2 translate-y-1 text-grey-40">
          {endLabel}
        </span>
      )}
    </div>
  ),
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
